import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ossCompanySelector = _resolveComponent("ossCompanySelector")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_BankAccountSelector = _resolveComponent("BankAccountSelector")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.displayConfig)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        "grid-list-md": "",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }, {
                default: _withCtx(() => [
                  (_ctx.displayReturnBtn)
                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                        key: 0,
                        variant: "flat",
                        size: "small",
                        color: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeImportMapping())),
                        icon: "$navigate_before"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "3",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filter.typeSearch,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.typeSearch) = $event)),
                    items: _ctx.importMappingType,
                    "item-value": "value",
                    label: "filtrer",
                    class: "mr-2",
                    clearable: "",
                    "item-title": (item) => item.label
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    "append-inner-icon": "$clear",
                    "data-cy": "companiesTable-search",
                    modelValue: _ctx.filter.search,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.search) = $event)),
                    "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.search = ''))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex align-center justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openAddDialog())),
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode(" Ajouter ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_data_table, {
            items: _ctx.importMap,
            headers: _ctx.dataHeader,
            class: "table",
            height: _ctx.height,
            "multi-sort": false,
            "fixed-header": "",
            "hide-default-footer": "",
            xs12: ""
          }, {
            "item.company": _withCtx(({ item }) => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_icon, {
                        icon: "$oss-edit",
                        onClick: ($event: any) => (_ctx.openEditDialog(item)),
                        elevation: "0",
                        color: "calendar_green",
                        disabled: false,
                        size: "small"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_col, { cols: "9" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.company.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            "item.origin": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.application": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.type": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.externalId": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.sourceName": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.sourceSiret": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.sourceIban": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value), 1)
            ]),
            "item.source": _withCtx(({ item }) => [
              _createVNode(_component_v_btn_trash, {
                onClick: ($event: any) => (_ctx.deleteImportMapping(item)),
                size: "small"
              }, null, 8, ["onClick"])
            ]),
            top: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end border-b"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filter.pagination.rowsPerPage,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filter.pagination.rowsPerPage) = $event)),
                        items: [5, 10, 25],
                        "hide-details": "",
                        class: "top-pagination",
                        style: {"min-width":"170px"},
                        prefix: "Lignes par page"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_1, _toDisplayString((_ctx.filter.pagination.page - 1) * _ctx.filter.pagination.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.filter.pagination.page - 1) * _ctx.filter.pagination.rowsPerPage +
                                _ctx.filter.pagination.rowsPerPage) + " de " + _toDisplayString(_ctx.filter.pagination.totalItems), 1),
                      _createVNode(_component_v_btn_prev, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.pagination.page--)),
                        disabled: _ctx.filter.pagination.page === 1,
                        size: "small"
                      }, null, 8, ["disabled"]),
                      _createVNode(_component_v_btn_next, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.pagination.page++)),
                        size: "small",
                        disabled: _ctx.nextPageDisabled
                      }, null, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["items", "headers", "height"]),
          (_ctx.dialog)
            ? (_openBlock(), _createBlock(_component_oss_dialog, {
                key: 0,
                modelValue: _ctx.dialog,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dialog) = $event)),
                title: "Interface d'import",
                actions: _ctx.actions,
                width: "80vw"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, { style: {"min-width":"650px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossCompanySelector, {
                                    modelValue: _ctx.selectId,
                                    "onUpdate:modelValue": [
                                      _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectId) = $event)),
                                      _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeCompanyId()))
                                    ],
                                    items: _ctx.allAvailableCompanies,
                                    selectClass: 'oss-dark',
                                    disabled: true,
                                    chipMaxLength: 9
                                  }, null, 8, ["modelValue", "items"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    modelValue: _ctx.newImport.origin,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newImport.origin) = $event)),
                                    items: _ctx.originEnum,
                                    label: "Origine",
                                    class: "mr-2",
                                    clearable: "",
                                    disabled: _ctx.disableDialog
                                  }, null, 8, ["modelValue", "items", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "9" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.newImport.application,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newImport.application) = $event)),
                                    label: "Application",
                                    class: "ml-2",
                                    "hide-details": "",
                                    disabled: _ctx.disableDialog
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    modelValue: _ctx.newImport.type,
                                    "onUpdate:modelValue": [
                                      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newImport.type) = $event)),
                                      _ctx.changeType
                                    ],
                                    items: _ctx.importMappingType,
                                    "item-value": "value",
                                    label: "Type",
                                    class: "mr-2",
                                    clearable: "",
                                    disabled: _ctx.edit,
                                    "item-title": (item) => item.label
                                  }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "disabled", "item-title"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "9" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    label: "Id externe",
                                    modelValue: _ctx.newImport.externalId,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newImport.externalId) = $event)),
                                    class: "ml-2",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.newImport.sourceName,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newImport.sourceName) = $event)),
                                    label: "Source (Nom)",
                                    class: "mr-2",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (_ctx.importMappingType[2].value === _ctx.newImport.type)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.newImport.sourceSiret,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newImport.sourceSiret) = $event)),
                                        label: "Source (Siret)",
                                        onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onInputSetTruncatedSiret())),
                                        class: "ml-2",
                                        "hide-details": "",
                                        maxlength: "14"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.importMappingType[3].value === _ctx.newImport.type)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    cols: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.newImport.sourceIban,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newImport.sourceIban) = $event)),
                                        label: "Source (IBAN)",
                                        onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onInputSetTruncatedIban())),
                                        class: "ml-2",
                                        "hide-details": "",
                                        maxlength: "32"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.importMappingType[1].value === _ctx.newImport.type)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_AccountableAccount, {
                                        showLabel: true,
                                        hideDetails: true,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.setAccountableAccount(_ctx.newImport, $event))),
                                        defineThirdParty: false,
                                        inAccountableAccount: _ctx.searchAccount
                                      }, null, 8, ["inAccountableAccount"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (
                                _ctx.importMappingType[0].value === _ctx.newImport.type ||
                                _ctx.importMappingType[2].value === _ctx.newImport.type ||
                                _ctx.importMappingType[3].value === _ctx.newImport.type
                            )
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    cols: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_input, {
                                        class: "v-input v-input--is-label-active v-input--is-dirty v-input--is-readonly v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined",
                                        onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.dialogSelect = true), ["stop"])),
                                        density: "compact",
                                        "hide-details": "",
                                        style: {"background-color":"rgb(var(--v-theme-background))","border-radius":"16px"},
                                        label: _ctx.newImport.sourceName ? '' : _ctx.selectedLabel
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "py-2 px-4"
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.newImport.userId)
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 0,
                                                    cols: "12",
                                                    class: "d-flex align-center",
                                                    style: {"white-space":"nowrap","font-size":"1.1rem","color":"black"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(this.newImport.userId.firstname +
                                            " " +
                                            this.newImport.userId.lastname), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (_ctx.newImport.thirdPartyCompanyId)
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 1,
                                                    cols: "12",
                                                    class: "d-flex align-center",
                                                    style: {"white-space":"nowrap"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(this.newImport.thirdPartyCompanyId.name), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (_ctx.newImport.bankAccountId)
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 2,
                                                    cols: "12",
                                                    class: "d-flex align-center",
                                                    style: {"white-space":"nowrap"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(this.newImport.bankAccountId.name), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["label"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.dialogSelect)
                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                    key: 2,
                                    modelValue: _ctx.dialogSelect,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialogSelect) = $event)),
                                    title: "Sélection",
                                    width: "60vw"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        style: {"min-width":"500px"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.importMappingType[0].value === _ctx.newImport.type)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "12"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_SelectUser, {
                                                    modelValue: _ctx.newImport.userId,
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newImport.userId) = $event)),
                                                    companyId: _ctx.newImport.companyId,
                                                    height: '40vh',
                                                    availableCompanyId: _ctx.newImport.companyId
                                                  }, null, 8, ["modelValue", "companyId", "availableCompanyId"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_ctx.importMappingType[2].value === _ctx.newImport.type)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 1,
                                                cols: "12"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_CompaniesTable, {
                                                    modelValue: _ctx.newImport.thirdPartyCompanyId,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newImport.thirdPartyCompanyId) = $event)),
                                                    parentCompanyId: _ctx.currentCompany.id,
                                                    showGenericCompany: true,
                                                    showConsumerCompany: true,
                                                    showCustomerCompanies: true,
                                                    showSupplierCompanies: true,
                                                    showExistingCompanies: false,
                                                    showNewCompanies: false
                                                  }, null, 8, ["modelValue", "parentCompanyId"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_ctx.importMappingType[3].value === _ctx.newImport.type)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 2,
                                                cols: "12"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_BankAccountSelector, {
                                                    modelValue: _ctx.newImport.bankAccountId,
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newImport.bankAccountId) = $event)),
                                                    companyId: _ctx.newImport.companyId
                                                  }, null, 8, ["modelValue", "companyId"])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "actions"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}